import { Button, Component, Enum, screen, _decorator } from 'cc';
import Game from '../../../Game';
import OrientationManager from '../../../OrientationManager';
import MultiThemeSource from '../MultiTheme/MultiThemeSource';

enum UnsupportedBehavior {
    None,
    Hide,
    Disable,
}

const { ccclass, property, requireComponent } = _decorator;

@ccclass('FullscreenButton')
@requireComponent(MultiThemeSource)
@requireComponent(Button)
export default class FullscreenButton extends Component {
    @property({ type: Enum(UnsupportedBehavior) })
    private readonly unsupportedBehavior: UnsupportedBehavior = UnsupportedBehavior.None;

    private _multiThemeSource: MultiThemeSource = null;
    private _button: Button = null;

    protected onLoad() {
        this._multiThemeSource = this.getComponent(MultiThemeSource);
        this._button = this.getComponent(Button);

        if (screen.supportsFullScreen && Game.config.enableFullScreen) {
            Game.orientation.on(OrientationManager.EVENT_TYPE.RESIZE, this._onResize, this);
            this.node.on(Button.EventType.CLICK, this._onFullscreenButtonClick, this);
        } else {
            this._handleUnsupportedBehavior();
        }
    }

    protected start() {
        this._onResize();
    }

    private _onResize() {
        this._multiThemeSource.theme = screen.fullScreen() ? 1 : 0;
    }

    private _onFullscreenButtonClick() {
        if (screen.fullScreen()) {
            screen.exitFullScreen();
        } else {
            screen.requestFullScreen();
        }
    }

    private _handleUnsupportedBehavior() {
        switch (this.unsupportedBehavior) {
            case UnsupportedBehavior.Hide:
                this.node.active = false;
                break;
            case UnsupportedBehavior.Disable:
                this._button.interactable = false;
                break;
            case UnsupportedBehavior.None:
            default:
                break;
        }
    }
}
